import { render, staticRenderFns } from "./detailContent.vue?vue&type=template&id=20f96802&scoped=true"
import script from "./detailContent.vue?vue&type=script&lang=ts"
export * from "./detailContent.vue?vue&type=script&lang=ts"
import style0 from "./detailContent.vue?vue&type=style&index=0&id=20f96802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f96802",
  null
  
)

export default component.exports